import { render, staticRenderFns } from "./strategy_auto_reply.vue?vue&type=template&id=3df5ff06&scoped=true"
import script from "./strategy_auto_reply.vue?vue&type=script&lang=js"
export * from "./strategy_auto_reply.vue?vue&type=script&lang=js"
import style0 from "./strategy_auto_reply.vue?vue&type=style&index=0&id=3df5ff06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df5ff06",
  null
  
)

export default component.exports